import clsx from 'clsx';

import { BoxElement } from './types';

const Box = ({ className, children, ...props }: BoxElement) => {
  return (
    <div {...props} className={clsx(className)}>
      {children}
    </div>
  );
};

export default Box;
